import MeetingInterfaces from './meetings';
import Reminders from './reminders';
import Tags from './tags';

class CalendarActivities {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/calendar-activities`;
    this.apiClient = apiClient;

    this.meetings = new MeetingInterfaces(this.basePath, this.apiClient);
    this.reminders = new Reminders(this.basePath, this.apiClient);
    this.tags = new Tags(basePath, this.apiClient);

  }

  async getPopulatedActivityById(activityId) {

    const path = `${this.basePath}/:activityId`;

    return this.apiClient.get(path, { activityId }, {});

  }

}

export default CalendarActivities;